import { useQuery } from "@tanstack/react-query";
import { getUserConsents, UserConsents } from "../services/get-user-consents";

export default function useUserConsents(userId: string) {
  const { data, isLoading, error } = useQuery<UserConsents, Error>({
    queryKey: ["user-consents", userId],
    queryFn: () => getUserConsents(userId),
    enabled: !!userId,
    refetchOnWindowFocus: false,
    staleTime: 1000 * 60 * 5,
  });

  return { data, isLoading, error };
}
